<template>
  <div style="height: 304px;margin-top: 8px;">
    <gj-table
        ref="gjTable"
        adaptParent
        :index="false"
        :data="tableData"
        :columns="columns"
        border="default"
        :loading="loading"
        @sort-change="$gjSortChange"
        layout="total, prev, pager, next"
        :default-sort="{prop: activeName, order: 'descending'}"
        :class="{'table-border':tableData.length>0}"
    >

      <template v-slot:header:campaignName="{}">
        {{ tableType === 'keyword' ? '关键词' : '广告活动' }}
      </template>

      <template v-slot:header:adsCost="{}">
        花费{{ currencySymbol | defaultShow('(',')') }}
      </template>

      <template v-slot:header:adsSales="{}">
        销售额{{ currencySymbol | defaultShow('(',')') }}
      </template>

      <template v-slot:rank="{row,index}">
        {{index + 1 + (pagination.currentPage-1)*20}}
      </template>

      <template v-slot:campaignName="{row}">

        <gj-popover trigger="hover" @show="getPopoverData(row)" placement="left" @after-leave="popoverData={}">

          <template slot="reference">
<!--            广告类型(0:商品，1：品牌，2：展示）-->
            <div class="colorBlue linkStr" v-if="tableType === 'keyword'" @click="routeTo(row,'adKeyword')">{{ setKeywordName(row.keywordText,row.matchType) }}</div>
            <div class="colorBlue linkStr" v-else @click="routeTo(row,'adCampaign')">{{ setCampaignName(row.campaignName,row.adType) }}</div>
          </template>

          <div :class="{'keywordLabel':tableType==='keyword'}">

            <div class="flex popover-line align-center">
              <span class="label color666">店铺/站点</span>
              <span class="colorBlack">{{popoverData.marketId | optionText(marketOption) | defaultShow}}</span>
              <span v-if="popoverData.status==='Inactive'" style="margin-left: 8px;">停用</span>
            </div>

            <div class="flex popover-line align-center">
              <span class="label color666">广告组合</span>
              <span class="colorBlack">{{popoverData.portfolioName | defaultShow}}</span>
            </div>

            <div class="flex popover-line align-center">
              <span class="label color666">广告活动</span>
              <gj-link @click="routeTo(row, 'adCampaign','popover')">{{setCampaignName(popoverData.campaignName,row.adType)}}</gj-link>
            </div>

            <template v-if="tableType==='keyword'">

              <div class="flex popover-line align-center">
                <span class="label color666">广告组</span>
                <gj-link @click="routeTo(row, 'adGroup','popover')">{{popoverData.groupName | defaultShow}}</gj-link>
              </div>

              <div class="flex popover-line align-center">
                <span class="label color666">关键词</span>
                <gj-link @click="routeTo(row, 'adKeyword','popover')">{{setKeywordName(popoverData.keywordText,row.matchType)}}</gj-link>>
              </div>

            </template>


            <div class="flex popover-line align-center" v-else>
              <span class="label color666">状态</span>
              <span class="colorBlack colorRed" v-if="popoverData.servingStatus==='CAMPAIGN_OUT_OF_BUDGET'">
                超出预算（超出时间{{popoverData.dailyBudgetLog | defaultShow}}）
              </span>
              <span class="colorBlack colorGreen" v-else-if="popoverData.servingStatus==='CAMPAIGN_STATUS_ENABLED'">
                正在投放
              </span>
              <span class="colorBlack" v-else>
                -
              </span>
            </div>

            <div class="flex popover-line align-center">
              <span class="label color666">投放类型</span>
              <span class="colorBlack">{{popoverData.targetType === 0?'手动投放':'自动投放'}}</span>
            </div>

            <div class="flex popover-line align-center">
              <span class="label color666">ASIN</span>
              <div class="flex" style="flex-wrap: wrap;max-width: 200px;">
                <gj-link :href="i.asinAmazonUrl" v-for="(i,index) in popoverData.asinList" :key="i.asin" target="_blank">
                  {{i.asin}}
                  <template v-if="index!==popoverData.asinList.length-1">,</template>
                </gj-link>
              </div>
<!--              <span class="colorBlack colorBlue">{{popoverData.portfolioName | defaultShow}}</span>-->
            </div>

            <template v-if="tableType==='keyword'">
              <div class="flex popover-line align-center">
                <span class="label color666">竞价</span>
                <span class="colorBlack">{{popoverData.bid | defaultShow(popoverData.bidCurrencySymbol,'')}}</span>
              </div>

              <div class="flex popover-line align-center">
                <span class="label color666">关键词监控</span>
                <span class="colorBlack" :class="{'colorGreen':popoverData.keywordMonitoringStatus === 0}">{{popoverData.keywordMonitoringStatus === 0?'已开启':'未开启'}}</span>
              </div>

              <template v-if="popoverData.keywordMonitoringStatus === 0">

                <div class="flex popover-line align-center">
                  <span class="label color666">广告排名</span>
                  <div class="colorBlack">
                    {{popoverData.keywordAdsRankPage | defaultShow}}
                    -
                    {{popoverData.keywordAdsCurrentRank | defaultShow}}
                    <i class="iconfont size12" :class="adsRank(popoverData)"></i>
<!--                    <i class="iconfont iconshangsheng1 size12 colorGreen" v-if="popoverData.keywordAdsRank-popoverData.yesterdayKeywordAdsRank>0"></i>-->
<!--                    <i class="iconfont iconxiajiang size12 colorRed" v-else-if="popoverData.keywordAdsRank-popoverData.yesterdayKeywordAdsRank<0"></i>-->
<!--                    <i class="iconfont iconhengxian size12" v-else></i>-->
                  </div>
                </div>

                <div class="flex popover-line align-center">
                  <span class="label color666">自然排名</span>
                  <div class="colorBlack">
                    {{popoverData.keywordNaturalRankPage | defaultShow}}
                    -
                    {{popoverData.keywordNaturalCurrentRank | defaultShow}}
                    <i class="iconfont size12" :class="naturalRank(popoverData)"></i>
<!--                    <i class="iconfont iconshangsheng1 size12 colorGreen" v-if="popoverData.keywordNaturalRank-popoverData.yesterdayKeywordNaturalRank>0"></i>-->
<!--                    <i class="iconfont iconxiajiang size12 colorRed" v-else-if="popoverData.keywordNaturalRank-popoverData.yesterdayKeywordNaturalRank<0"></i>-->
<!--                    <i class="iconfont iconhengxian size12" v-else></i>-->
                  </div>
                </div>

              </template>

            </template>

            <template v-else>
              <div class="flex popover-line align-center">
                <span class="label color666">每日预算</span>
                <span class="colorBlack">{{popoverData.budget | defaultShow(popoverData.budgetCurrencySymbol,'')}}</span>
              </div>

              <div class="flex popover-line align-center">
                <span class="label color666">竞价策略</span>
                <span class="colorBlack">{{popoverData.bidStrategy | bidStrategy}}</span>
              </div>
            </template>

            <div class="flex popover-line align-center">
              <span class="label color666">分时策略</span>
              <span class="colorBlack colorGreen" v-if="popoverData.strategyStatus === 0">已开启</span>
              <span class="colorBlack" v-if="popoverData.strategyStatus === 1">已关闭</span>
              <span class="colorBlack" v-if="popoverData.strategyStatus === 2">未添加</span>

            </div>

            <div class="flex popover-line align-center" v-if="activeName==='acos'">
              <span class="label color666">ACOS</span>
              <span class="colorBlack">今日：{{popoverData.totalAcos | defaultShow('','%')}}</span>
              <span class="colorBlack" style="padding: 0 12px;">昨日：{{popoverData.yesterdayAcos | defaultShow('','%')}}</span>
              <span class="colorBlack">上周同日：{{popoverData.lastWeekDayAcos | defaultShow('','%')}}</span>
            </div>
            <div class="flex popover-line align-center" v-if="activeName==='ctr'">
              <span class="label color666">CTR</span>
              <span class="colorBlack">今日：{{popoverData.totalCtr | defaultShow('','%')}}</span>
              <span class="colorBlack" style="padding: 0 12px;">昨日：{{popoverData.yesterdayCtr | defaultShow('','%')}}</span>
              <span class="colorBlack">上周同日：{{popoverData.lastWeekDayCtr | defaultShow('','%')}}</span>
            </div>
            <div class="flex popover-line align-center" v-if="activeName==='cvr'">
              <span class="label color666">CVR</span>
              <span class="colorBlack">今日：{{popoverData.totalCvr | defaultShow('','%')}}</span>
              <span class="colorBlack" style="padding: 0 12px;">昨日：{{popoverData.yesterdayCvr | defaultShow('','%')}}</span>
              <span class="colorBlack">上周同日：{{popoverData.lastWeekDayCvr | defaultShow('','%')}}</span>
            </div>
          </div>


        </gj-popover>

      </template>

      <template v-slot:acos="{row}">
        {{row.acos | defaultShow('','%')}}
        <i class="iconfont iconshangsheng1 size12 colorGreen" v-if="row.acos-row.previousPeriodAcos>0"></i>
        <i class="iconfont iconxiajiang size12 colorRed" v-else-if="row.acos-row.previousPeriodAcos<0"></i>
        <i class="iconfont iconhengxian size12 color999" v-else></i>
      </template>

      <template v-slot:ctr="{row}">
        {{row.ctr | defaultShow('','%')}}
        <i class="iconfont iconshangsheng1 size12 colorGreen" v-if="row.ctr-row.previousPeriodCtr>0"></i>
        <i class="iconfont iconxiajiang size12 colorRed" v-else-if="row.ctr-row.previousPeriodCtr<0"></i>
        <i class="iconfont iconhengxian size12 color999" v-else></i>
      </template>

      <template v-slot:cvr="{row}">
        {{row.cvr | defaultShow('','%')}}
        <i class="iconfont iconshangsheng1 size12 colorGreen" v-if="row.cvr-row.previousPeriodCvr>0"></i>
        <i class="iconfont iconxiajiang size12 colorRed" v-else-if="row.cvr-row.previousPeriodCvr<0"></i>
        <i class="iconfont iconhengxian size12 color999" v-else></i>
      </template>

    </gj-table>
  </div>
</template>

<script>
import {dashboardMixin, queryMixin} from "@/minxins";
import {currentCampaignHover, currentCampaignRank, currentKeywordHover, currentKeywordRank} from "@/api/dashboard";
import {mapGetters} from "vuex";
import {isMeaningful, isMeaningless} from "@/utils/common";

export default {
  name: "ACOS-rank",
  mixins: [queryMixin, dashboardMixin],
  props: {
    name:null,
    activeName:null,// acos\ctr\cvr
    tableType: null,// 活动、关键词
    columns:{
      type:Array,
      default:()=>[]
    },
    currencySymbol:null
  },
  data() {
    return {
      loading:false,


      tableData: [],

      popoverData:{}
    }
  },
  filters: {
    bidStrategy(val) {
      let item = [
        {id: 0, text: '动态竞价-只降低'},
        {id: 1, text: '动态竞价-提高和降低'},
        {id: 2, text: '固定竞价'},
      ].find(e => e.id == val)
      return item ? item.text : "-"
    }
  },
  computed: {
    ...mapGetters(['marketOption', 'authMarkets']),
    filter() {
      return {
        tableType: this.tableType,
        currency: this.dashboardCurrency,
        dateTime: this.timezoneText,
        activeName: this.activeName,
        countryMarket:this.countryMarket
      }
    }
  },
  watch:{
    activeName:{
      handler(){
        this.sort.prop = this.activeName
      },
      immediate: true
    }
  },
  methods: {
    // 广告类型(0:商品sp，1：品牌sB，2：展示sD）
    setCampaignName(text,val){
      if(!text) return '-'
      if(val === 0){
        return 'SP:'+text
      }else if(val === 1){
        return 'SB:'+text
      }else if(val === 2){
        return 'SD:'+text
      }
    },
    // 关键词类型（0:精确匹配, 1:词组匹配, 2:广泛匹配）
    setKeywordName(text,val){
      if(!text) return '-'
      if(val === 0){
        return '精确匹配:'+text
      }else if(val === 1){
        return '词组匹配:'+text
      }else if(val === 2){
        return '广泛匹配:'+text
      }
    },
    adsRank(){
      if(this.popoverData.keywordAdsRankPage-this.popoverData.yesterdayKeywordAdsRankPage<0){
        return {'iconshangsheng1':true, 'colorGreen':true}
      }else if(this.popoverData.keywordAdsRankPage-this.popoverData.yesterdayKeywordAdsRankPage>0){
        return {'iconxiajiang':true, 'colorRed':true}
      }else {
        if(this.popoverData.keywordAdsCurrentRank-this.popoverData.yesterdayKeywordAdsCurrentRank<0){
          return {'iconshangsheng1':true, 'colorGreen':true}
        }else if(this.popoverData.keywordAdsCurrentRank-this.popoverData.yesterdayKeywordAdsCurrentRank>0){
          return {'iconxiajiang':true, 'colorRed':true}
        }else {
          return {'iconhengxian':true}
        }
      }
    },
    naturalRank(){
      if(this.popoverData.keywordNaturalRankPage-this.popoverData.yesterdayKeywordNaturalRankPage<0){
        return {'iconshangsheng1':true, 'colorGreen':true}
      }else if(this.popoverData.keywordNaturalRankPage-this.popoverData.yesterdayKeywordNaturalRankPage>0){
        return {'iconxiajiang':true, 'colorRed':true}
      }else {
        if(this.popoverData.keywordNaturalCurrentRank-this.popoverData.yesterdayKeywordNaturalCurrentRank<0){
          return {'iconshangsheng1':true, 'colorGreen':true}
        }else if(this.popoverData.keywordNaturalCurrentRank-this.popoverData.yesterdayKeywordNaturalCurrentRank>0){
          return {'iconxiajiang':true, 'colorRed':true}
        }else {
          return {'iconhengxian':true}
        }
      }
    },
    routeTo(row, type, popover){
      let path,keyword;
      if(popover){
        if(type === 'adCampaign'){
          keyword = this.popoverData.campaignName;
        }else if(type === 'adKeyword'){
          keyword = this.popoverData.keywordText;
        }else if(type === 'adGroup'){
          keyword = this.popoverData.groupName;
        }
      }else {
        if(type === 'adCampaign'){
          keyword = row.campaignName;
        }else if(type === 'adKeyword'){
          keyword = row.keywordText;
        }else if(type === 'adGroup'){
          keyword = row.groupName;
        }
      }

      // 广告类型(0:商品，1：品牌，2：展示）
      if(row.adType === 0){
        path = '/ad/sp-ad/ad-manager';
      }else if(row.adType === 1){
        path = '/ad/sb-ad/ad-manager';
      }else if(row.adType === 2){
        path = '/ad/sd-ad/ad-manager';
      }
      this.$router.push({
        path,
        query:{
          activeTabMap: type,
          keyword,
          marketId: row.marketId,
          timeStamp:new Date().getTime()
        }
      })
    },
    $gjQuery(){
      // 缓存了时区时，第一次不请求
      if(isMeaningful(this.timezoneId)&&isMeaningless(this.timezoneText)){
        return
      }
      if(this.name!==this.activeName){
        return
      }
      this.loading = true
      let params = {
        model: {
          currency:this.dashboardCurrency,
          dateTime:this.timezoneText,
          // dateTime: '2022-02-18 12:12:12',
          countrys: this.countryMarket.countryIds,// 国家
          marketIds: this.countryMarket.marketIds,// 店铺
        },
        current:1,
        size:50,
        ...this.querySort,
      };
      if(this.tableType === 'campaign'){
        currentCampaignRank(params).then(res=>{
          this.tableData = res.records;
          this.pagination = this.getPagination(res);
        }).complete(()=>{
          this.loading = false;
        })
      }else if(this.tableType === 'keyword'){
        currentKeywordRank(params).then(res=>{
          this.tableData = res.records;
          this.pagination = this.getPagination(res);
        }).complete(()=>{
          this.loading = false;
        })
      }

    },
    getPopoverData(row){
      let param = `?adType=${row.adType}&dateTime=${this.timezoneText||''}&marketId=${row.marketId}`
      // 活动悬浮窗
      if(this.tableType === 'campaign'){
        currentCampaignHover(param+`&campaignId=${row.campaignId}`).then(res=>{
          this.popoverData = res;
          this.popoverData.status = this.authMarkets.find(r=>r.id===this.popoverData.marketId)?.status
        })
      }
      //关键词悬浮窗
      else if(this.tableType === 'keyword'){
        // let param = `?adType=${row.adType}&keywordId=${row.keywordId}&dateTime=2022-02-18&marketId=${row.marketId}`
        currentKeywordHover(param+`&keywordId=${row.keywordId}`).then(res=>{
          this.popoverData = res
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.label {
  text-align: right;
  flex: none;
  width: 54px;
  padding-right: 12px;
}

.keywordLabel {
  .label {
    width: 60px;
  }
}

.popover-line {
  //height: 18px;
  align-items: start;
}

.popover-line + .popover-line {
  margin-top: 8px;
}
.linkStr{
  cursor: pointer;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-wrap: break-word;
}
</style>